import React, { useEffect, useState } from "react";
import { Box, CssBaseline } from "@mui/material";
import SideBar from "../sidebar/SideBar";
import ContentArea from "../content-area/ContentArea";
import DashboardHeader from "../dashboardHeader/DashboardHeader";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getCarrierByBusinessName } from "../../redux/action/carrier";
import { unwrapResult } from "@reduxjs/toolkit";

const Layout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeComponent, setActiveComponent] = useState("CarrierInfo");
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <DashboardHeader
        sidebarOpen={sidebarOpen}
        toggleSidebar={toggleSidebar}
      />
      <SideBar
        sidebarOpen={sidebarOpen}
        setActiveComponent={setActiveComponent}
        toggleSidebar={toggleSidebar}
      />
      <ContentArea
        sidebarOpen={sidebarOpen}
        activeComponent={activeComponent}
        setActiveComponent={setActiveComponent}
      />
    </Box>
  );
};

export default Layout;
